/*
 * Module for viewing and changing campaigns
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./campaignsView",
  "./campaignList/campaignListModule",
  "./campaign/campaignModule",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  CampaignView,
  CampaignListModule,
  CampaignModule,
  KbMenuModel,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "Campaigns";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.campaigns = Messenger.reqres.request("fetch:kb:campaigns");
      Messenger.onSave(function () {
        // each campaign is saved individually when another campaign in the list is selected.
        // But if the user clicks outside the list for example, topics section then the last
        // modified campaign will be saved by saving the collection.
        this.campaigns.saveCollection();
      }, this);

      this.campaigns.onSynced(function () {
        this.layout = new CampaignView.campaignsView({ model: this.campaigns });

        this.campaign = this.addSubModule(new CampaignModule({ region: this.layout.campaign }));
        this.campaignList = this.addSubModule(
          new CampaignListModule({
            region: this.layout.campaignList,
            nameAttribute: "name",
          }),
        );

        this.layout.on("add:campaign", this._addCampaign, this);

        this.showRegion(this.layout, { loading: false });
        this._showSubViews();
      }, this);
    },
    _addCampaign: function () {
      Messenger.save((success) => {
        if (success) {
          const newCampaign = this.campaigns.addCampaign();
          this.campaignList.selectItem(newCampaign);
        }
      });
    },
    _showSubViews: function () {
      this.campaignList.show(this.campaigns);
    },
    _setUpVents: function () {
      //Show the campaigns admin screen
      Messenger.vent.on("show:authoring:admin:campaigns", () => {
        const kbId = Messenger.reqres.request("active:kb");
        Backbone.history.navigate(kbId + "/authoringAdmin/campaigns");
        this.show();
      });
      //show the module
      Messenger.vent.on("show:kb:admin:campaigns", () => {
        const kbId = Messenger.reqres.request("active:kb");
        Backbone.history.navigate(kbId + "/authoringAdmin/campaigns");
        this.show();
      });
      Messenger.vent.on("delete:campaign", (model) => {
        model.deleteModel(); //deleting the model triggers the selectable list to no longer consider this model selected
      });
    },
  });
});
